import { Link, Navigate, useLocation } from "react-router-dom";
import { Button } from "antd";
import { useContext } from "react";
import AppContext from "../../../utilities/contexts/appContext";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import i18n from "../../../locales/i18n";
const Guest = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const appContext = useContext(AppContext);

  if (appContext.token) {
    return <Navigate to={`/${i18n.language}/dashboard`} />;
  }
  return (
    <div id="guest" className="flex justify-start pt-[9.375rem] h-screen items-center flex-col p-5 w-full overflow-y-auto">
      <div className="flex flex-col items-center justify-center w-full mx-auto md:w-6/12 lg:w-3/12">
        <div className="flex flex-col items-center gap-4">
          <img className="w-[6.25rem] " alt="" src="/logo_white.png" />
          <p className="text-xl font-bold text-white">{t("guest.welcome")}</p>
        </div>
        <div className="grid w-full grid-cols-1 gap-3">
          <Link state={location.state} className="w-full " to={`/${i18next.language}/login`}>
            <Button size="large" className="w-full btn-white">
              {t("guest.login")}
            </Button>
          </Link>
          {/* <Link className="w-full" to={`/${i18next.language}/guest/body-measurement`}>
            <Button size="large" type="default" className="w-full mt-5 btn-white-outline">
              {t("guest.freeTrial")}
            </Button>
          </Link> */}
          <Link className="w-full " to={`/${i18next.language}/guest/services`}>
            <Button size="large" type="default" className="w-full mt-5 btn-white-outline">
              {t("guest.freeTrial")}
            </Button>
          </Link>
        </div>
        <div className="flex justify-center gap-4 mt-6">
          <a href="/terms_conditions.html" target="_blank" rel="noopener noreferrer" className="text-sm text-white underline">
            {t("guest.termsAndConditions")}
          </a>
          <span className="text-white">|</span>
          <a href="/privacy_policy.html" target="_blank" rel="noopener noreferrer" className="text-white underline text-sm">
            {t("guest.privacyPolicy")}
          </a>
        </div>
      </div>
    </div>
  );
};
export default Guest;
